'use strict';

const { CLASSES } = require('../utils/globals');
const SELECTORS = {
    imageThumnails: '.js-look-thumbnails',
    memberLookContainer: '.member-look-container',
    myLooksContainer: '.looks-listing-main-container',
    limitedSizeMsg: '.js-limited-size-msg',
    limitedSizeBadge: '.js-limited-size-badge',
    lookCard: '.c-look-card',
    lookName: '.js-look-name',
    imageThumnailsCarousel: '.js-thumbnails-carousel',
    memberLookQuickViewModalContent: '.js-look-quickview-modal-content'
};

var { tns } = require("tiny-slider");

const loadLookImages = ($imageThumnail) => {
    let lookId = $imageThumnail.data('lookid');
    let $memberLookQuickViewModalContent = $('.js-member-card-' + lookId).find(SELECTORS.memberLookQuickViewModalContent);

    if (!$imageThumnail.find('.veil').length) {
        $imageThumnail.spinner().start();
        $memberLookQuickViewModalContent.spinner().start();
    }

    $imageThumnail.removeClass(CLASSES.isError);

    $.ajax({
        url: $imageThumnail.data('url'),
        type: 'GET',
        dataType: 'HTML',
        success: (response) => {
            $imageThumnail.html(response).addClass(CLASSES.active);

            // Show the limited size notice in my looks tab.
            let $memberLookContainer = $imageThumnail.parents(SELECTORS.memberLookContainer);
            let $myLooksContainer = $imageThumnail.parents(SELECTORS.myLooksContainer);

            if ($memberLookContainer.length > 0 || $myLooksContainer.length > 0) {
                let $lookCard = $imageThumnail.parents(SELECTORS.lookCard);
                let $limitedSizeMsg = $lookCard.find(SELECTORS.limitedSizeMsg);
                let $limitedSizeBadge = $lookCard.find(SELECTORS.limitedSizeBadge);

                if ($limitedSizeMsg.length > 0) {
                    $limitedSizeMsg.removeClass(CLASSES.hide);
                    $limitedSizeBadge.removeClass(CLASSES.hide);
                }
            }

            // create a slider.
            let tnsParams = {
                items: 1,
                loop: false,
                navAsThumbnails: "false",
                mouseDrag: "true",
                swipeAngle: false,
                speed: 400
            }

            if ($memberLookQuickViewModalContent.length > 0) {
                $memberLookQuickViewModalContent.html(response);
                let $carousel = $memberLookQuickViewModalContent.find('.js-thumbnails-carousel');
                if ($carousel.length > 0) {
                    tnsParams.container = $carousel.get(0);
                    tns(tnsParams);
                }
            }

            let tnsContainer = '.js-look-thumbnails-' + lookId + ' .js-thumbnails-carousel';
            if ($(tnsContainer).length > 0) {
                tnsParams.container = tnsContainer
                tns(tnsParams);
            }
        },
        error: () => {
            $imageThumnail.addClass(CLASSES.isError).removeClass(CLASSES.active);
        },
    });
};

const initLooksImagesObserver = function () {
    // Select all target elements using the selector
    var targets = document.querySelectorAll(SELECTORS.imageThumnails);

    // Iterate over each target element and trigger the desired action
    targets.forEach(function (target) {
        let $imageThumnail = $(target);
        if (!$imageThumnail.length || $imageThumnail.hasClass(CLASSES.active)) {
            return;
        }

        loadLookImages($imageThumnail);
    });
};

// Ensure the function runs after the page is fully loaded
window.addEventListener('load', initLooksImagesObserver);

module.exports = {
    initLooksImagesObserver: initLooksImagesObserver,
};